export enum ProductType {

    SERVICE = 'SERVICE',
    CONSUMABLE = 'CONSUMABLE',
    STORABLE_PRODUCT = 'STORABLE_PRODUCT',

}
